import { classNames } from '@utils/classNames';

export type IParameterListHeaderItem = {
  label: string;
  className?: string;
};

export const ParameterListHeaderItem = ({
  label,
  className,
}: IParameterListHeaderItem) => {
  return (
    <div
      className={classNames(
        'text-dark font-outfit text-base font-bold leading-[27px]',
        className,
      )}
    >
      {label}
    </div>
  );
};
